import { ReactNode, useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Flex from "../../../../components/Flex";
import CustomTabs from "../../../../components/app/CustomTabs";
import StyledButtonV2 from "../../../../components/app/StyledButtonV2";
import useDisclosure from "../../../../hooks/use-disclosure";
import UpsertInsuranceFormModal from "../../../../pages/app/provider/patient/patient-list/patient-chart-new/demographics/insurance/UpsertInsuranceFormDrawer";
import PatientSectionWrapper from "../PatientSectionWrapper";
import PatientPortalChangePassword from "./PatientPortalChangePassword";
import PatientPortalEditPatientForm from "./PatientPortalEditPatientForm";

const TABS_DATA = [
  {
    label: "Profile",
    value: "",
  },
  {
    label: "Insurance",
    value: "insurance",
  },
  {
    label: "Notifications",
    value: "notifications",
  },
];

const ProviderPortalPatientSettings = () => {
  const path = location.pathname.split("/").pop();
  const currentTab = path === "settings" ? "" : (path as string);
  const [activeTab, setActiveTab] = useState<string>(currentTab ?? "");
  const [isEditProfileOpen, setIsEditProfileOpen] = useState(false);
  const addPatientInsuranceDisclosure = useDisclosure();
  const [isChangePasswordOpen, setIsChangePasswordOpen] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    setActiveTab(currentTab ?? "");
  }, [currentTab]);

  const handleTabChange = (tab: string) => {
    setActiveTab(tab);
    navigate(tab);
  };

  const handleChangePassword = () => {
    setIsChangePasswordOpen(true);
  };

  const handleEditProfile = () => {
    setIsEditProfileOpen(true);
  };

  const endActionMapper: Record<string, ReactNode> = {
    "": (
      <Flex gap={1} height={"100%"}>
        <StyledButtonV2
          variant="outlined"
          color="primary"
          onClick={handleChangePassword}
          label="Change Password"
        />
        <StyledButtonV2
          variant="contained"
          color="primary"
          onClick={handleEditProfile}
          label="Edit Profile"
        />
      </Flex>
    ),
    insurance: (
      <StyledButtonV2
        onClick={() => addPatientInsuranceDisclosure.open()}
        label="Add Insurance"
        variant="contained"
        color="primary"
      />
    ),
  };

  return (
    <PatientSectionWrapper
      header={
        <CustomTabs
          tabsData={TABS_DATA}
          value={activeTab}
          onChange={handleTabChange}
        />
      }
      endAction={endActionMapper[activeTab] ?? undefined}
    >
      <Outlet />
      <PatientPortalEditPatientForm
        open={isEditProfileOpen}
        onClose={() => setIsEditProfileOpen(false)}
      />

      {addPatientInsuranceDisclosure.opened && (
        <UpsertInsuranceFormModal
          disClosureHost={addPatientInsuranceDisclosure}
          title="Add Insurance"
        />
      )}
      <PatientPortalChangePassword
        open={isChangePasswordOpen}
        onClose={() => setIsChangePasswordOpen(false)}
      />
    </PatientSectionWrapper>
  );
};

export default ProviderPortalPatientSettings;
